/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import FloatCart from '@/components/FloatCart';
import '@/resources/font/iconfont.css';
export default {
  name: 'mall',
  components: {
    FloatCart: FloatCart
  },
  data: function data() {
    return {
      linkName: '',
      vshow: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var linkName = to.name;
      vm.showFloatCart(linkName);
    });
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: {},
  watch: {
    $route: function $route(val) {
      var linkName = val.name;
      this.showFloatCart(linkName);
    }
  },
  methods: {
    showFloatCart: function showFloatCart(linkName) {
      if (linkName == 'MallIndex' || linkName == 'MallGoodsList') {
        this.vshow = true;
      } else {
        this.vshow = false;
      }
    }
  }
};
Vue.prototype.$bus = new Vue();